import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { Shell } from '@/components/Shell';
import { useApp } from './state';
import { WelcomePage } from '@/pages/Welcome';
import { ReceptionPage } from '@/pages/Reception';
import { QueuePage } from '@/pages/Queue';
import { BoardPage } from '@/pages/Board';
import { PatientsPage } from '@/pages/Patients';
import { PatientPage } from '@/pages/Patient';
import { SettingsPage } from '@/pages/Settings';
import { ConsultPage } from '@/pages/Consult';
import { DispensePage } from '@/pages/Dispense';
import { StockPage } from '@/pages/Stock';
import { DeviceSetupPage } from '@/pages/DeviceSetup';
import { MODE_HOME, getDeviceMode } from './device';

function RequireClinic() {
  const { ready, session, crypto } = useApp();
  if (!ready) return <div className="p-8 text-center text-muted">…</div>;
  if (!session || !crypto) return <Navigate to="/welcome" replace />;
  if (!getDeviceMode() && session.mode === 'cloud') return <Navigate to="/device-setup" replace />;
  return <Outlet />;
}

function Home() {
  return <Navigate to={MODE_HOME[getDeviceMode() ?? 'full']} replace />;
}

function RequireSession() {
  const { ready, session, crypto } = useApp();
  if (!ready) return null;
  if (!session || !crypto) return <Navigate to="/welcome" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  { path: '/welcome', element: <WelcomePage /> },
  { path: '/device-setup', element: <RequireSession />, children: [{ index: true, element: <DeviceSetupPage /> }] },
  { path: '/board', element: <RequireClinic />, children: [{ index: true, element: <BoardPage /> }] },
  {
    path: '/', element: <RequireClinic />, children: [
      {
        element: <Shell />, children: [
          { index: true, element: <Home /> },
          { path: 'reception', element: <ReceptionPage /> },
          { path: 'queue', element: <QueuePage /> },
          { path: 'consult/:tokenId', element: <ConsultPage /> },
          { path: 'dispense', element: <DispensePage /> },
          { path: 'stock', element: <StockPage /> },
          { path: 'patients', element: <PatientsPage /> },
          { path: 'patients/:id', element: <PatientPage /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
]);
